import { useSocketContext } from "../context/SocketContext";

/**
 * Hook for accessing the WebSocket connection.
 *
 * Provides:
 * - `socket` — the raw Socket.IO client instance (or null if not connected)
 * - `connected` — boolean indicating current connection status
 * - `subscribe(event, handler)` — registers an event listener; returns an unsubscribe function
 * - `emit(event, payload?)` — sends an event to the server (no-op if disconnected)
 *
 * Usage:
 * ```ts
 * const { subscribe, emit, connected } = useSocket();
 *
 * useEffect(() => {
 *   const unsub = subscribe("new_message", (msg) => { ... });
 *   return unsub;
 * }, [subscribe]);
 * ```
 */
export function useSocket() {
  return useSocketContext();
}
